var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23.2,
  height: 23
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Settings_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h23.2v23H0z",
  className: "Settings_svg__cls-1"
})), /*#__PURE__*/React.createElement("style", null, ".Settings_svg__cls-1{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Settings_svg__Settings",
  clipPath: "url(#Settings_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Settings_svg__\\uC0AC\\uAC01\\uD615_193",
  d: "M0 0h23v23H0z",
  className: "Settings_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Settings_svg__\\uD328\\uC2A4_104",
  fill: "#1291d9",
  fillRule: "evenodd",
  d: "M270.954 14.375a2.875 2.875 0 1 0-2.921-2.875 2.907 2.907 0 0 0 2.921 2.875m-5.988-9.2a8.3 8.3 0 0 1 3.505-1.869L269.639 0h2.921l1.168 3.306a10.3 10.3 0 0 1 3.505 1.869l3.505-.719 1.462 2.588-2.337 2.588a8 8 0 0 1 .146 1.869c0 .575-.146 1.294-.146 1.869l2.337 2.587-1.461 2.587-3.505-.719a8.3 8.3 0 0 1-3.505 1.869L272.561 23h-2.921l-1.168-3.306a10.3 10.3 0 0 1-3.505-1.869l-3.505.719L260 15.956l2.337-2.587a8 8 0 0 1-.146-1.869c0-.575.146-1.294.146-1.869L260 7.044l1.461-2.587z",
  transform: "translate(-259)"
}))));
export { SvgSettings as ReactComponent };
export default __webpack_public_path__ + "static/media/Settings.cfea629e.svg";